<form [formGroup]="form" (ngSubmit)="submit()">
  <un-input
    type="email"
    formControlName="email"
    label="Email"
    i18n-label="@@email"
  ></un-input>
  <button class="primary large t-large" type="submit" i18n="@@resetPassword">
    Reset Password
  </button>
</form>

<div class="register">
  <span i18n="@@rememberYourPassword">Remember your password? </span>
  <a
    [routerLink]="loginLink"
    queryParamsHandling="merge"
    class="c-primary"
    i18n="@@signIn"
    (click)="modalRef?.close({ signIn: true })"
    >Sign In</a
  >
</div>
